module.exports = __webpack_public_path__ + "img/A2_HQ02.0faaa32e.jpg";